/* tslint:disable */
/* eslint-disable */
/**
 * app
 * app
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { State } from './State';
import {
    StateFromJSON,
    StateFromJSONTyped,
    StateToJSON,
} from './State';

/**
 * 
 * @export
 * @interface FindAllStates200Response
 */
export interface FindAllStates200Response {
    /**
     * 
     * @type {Array<State>}
     * @memberof FindAllStates200Response
     */
    data?: Array<State>;
}

/**
 * Check if a given object implements the FindAllStates200Response interface.
 */
export function instanceOfFindAllStates200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindAllStates200ResponseFromJSON(json: any): FindAllStates200Response {
    return FindAllStates200ResponseFromJSONTyped(json, false);
}

export function FindAllStates200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllStates200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(StateFromJSON)),
    };
}

export function FindAllStates200ResponseToJSON(value?: FindAllStates200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(StateToJSON)),
    };
}

